import { useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "../context/AuthContext";
import { uploadFiles } from "../services/fileServices";
import { handleErrors } from "../services/handleErrors";

const useFiles = () => {
  const { refreshToken } = useAuth();
  const [isUploadingFiles, setIsUploadingFiles] = useState(false);

  const handleUploadFileButton = () => {
    document.getElementById("upfile").click();
  };

  const handleUploadFiles = async ({ entity, entityId, handleFilesUploaded }) => {
    const selectedFiles = document.getElementById("upfile").files;

    if (selectedFiles && selectedFiles.length > 0) {
      setIsUploadingFiles(true);
      try {
        await uploadFiles({ entity, entityId, files: selectedFiles });
        toast.success(selectedFiles.length > 1 ? `${selectedFiles.length} archivos subidos exitosamente!` : `Archivo ${selectedFiles[0].name} subido exitosamente!`);
        document.getElementById("upfile").value = "";
      } catch (err) {
        handleErrors(err, toast.error, refreshToken);
      } finally {
        if (handleFilesUploaded) {
          handleFilesUploaded();
        }
        setIsUploadingFiles(false);
      }
    }
  };

  return [isUploadingFiles, handleUploadFileButton, handleUploadFiles];
};

export { useFiles };
